import Vue from "vue";
import Router from "vue-router";
//首页
const Index = () => import("../views/index/index.vue");
const AuctionIndex = () => import("../views/auction/index.vue");
const AuctionDetail = () => import("../views/auction/detail.vue");
const AuctionItem = () => import("../views/auction/item.vue");
const EverybodyIndex = () => import("../views/everybody/index.vue");
const NewsIndex = () => import("../views/news/index.vue");
const NewsDetail = () => import("../views/news/detail.vue");
const CollectIndex = () => import("../views/collect/index.vue");
const ArtistIndex = () => import("../views/artist/index.vue");
const ArtistPage = () => import("../views/artist/page.vue");
const AboutIndex = () => import("../views/about/index.vue");
const UserCenter = () => import("../views/usercenter/welcome.vue");
const UserCenterIndex = () => import("../views/usercenter/index.vue");
const Order = () => import("../views/usercenter/order.vue");
const Address = () => import("../views/usercenter/address.vue");
const HistoryPrice = () => import("../views/usercenter/history.vue");
const Deposit = () => import("../views/usercenter/deposit.vue");
const Wuliu = () => import("../views/usercenter/wuliu.vue");
const Zhengshu = () => import("../views/about/zhengshu.vue");
const Login = () => import("../views/login/index.vue");
const Checkout = () => import("../views/checkout/index.vue");
const Search = () => import("../views/search/index.vue");
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "",
      redirect: "/index/index"
    },
    {
      path: "/index/index",
      name: "index",
      component: Index,
      meta: {
        title: "杏坛艺拍---买卖书画上杏坛艺拍",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/auction/index",
      name: "auctionindex",
      component: AuctionIndex,
      meta: {
        title: "专场拍卖"
      }
    },
    {
      path: "/auction/detail",
      name: "auctiondetail",
      component: AuctionDetail,
      meta: {
        title: "专场详情"
      }
    },
    {
      path: "/auction/item",
      name: "auctionitem",
      component: AuctionItem,
      meta: {
        title: "作品详情"
      }
    },
    {
      path: "/everybody/index",
      name: "everybodyIndex",
      component: EverybodyIndex,
      meta: {
        title: "大家拍"
      }
    },
    {
      path: "/news/index",
      name: "newsIndex",
      component: NewsIndex,
      meta: {
        title: "资讯"
      }
    },
    {
      path: "/news/detail",
      name: "newsdetail",
      component: NewsDetail,
      meta: {
        title: "资讯详情"
      }
    },
    {
      path: "/collect/index",
      name: "collectIndex",
      component: CollectIndex,
      meta: {
        title: "作品征集"
      }
    },
    {
      path: "/artist/index",
      name: "artistIndex",
      component: ArtistIndex,
      meta: {
        title: "艺术家列表"
      }
    },
    {
      path: "/artist/page",
      name: "artistpage",
      component: ArtistPage,
      meta: {
        title: "艺术家主页"
      }
    },
    {
      path: "/about/index",
      name: "aboutIndex",
      component: AboutIndex,
      meta: {
        title: "关于我们"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/about/zhengshu",
      name: "zhengshu",
      component: Zhengshu,
      meta: {
        title: "拍卖证书"
      }
    },

    {
      path: "/usercenter",
      name: "usercenter",
      component: UserCenter,
      meta: {
        title: "个人中心"
      },
      children: [
        {
          path: "/usercenter/index",
          name: "usercenterindex",
          component: UserCenterIndex,
          meta: {
            title: "个人中心",
            requiresAuth: true
          }
        },
        {
          path: "/usercenter/order",
          name: "order",
          component: Order,
          meta: {
            title: "订单中心",
            requiresAuth: true
          }
        },
        {
          path: "/usercenter/history",
          name: "historyPrice",
          component: HistoryPrice,
          meta: {
            title: "出价历史",
            requiresAuth: true
          }
        },
        {
          path: "/usercenter/address",
          name: "address",
          component: Address,
          meta: {
            title: "收货地址",
            requiresAuth: true
          }
        },
        {
          path: "/usercenter/deposit",
          name: "deposit",
          component: Deposit,
          meta: {
            title: "保证金",
            requiresAuth: true
          }
        },
        {
          path: "/checkout",
          name: "checkout",
          component: Checkout,
          meta: {
            title: "收银台"
          }
        },
        {
          path: "/usercenter/wuliu",
          name: "wuliu",
          component: Wuliu,
          meta: {
            title: "物流查询"
          }
        }
      ],
      redirect: "/usercenter/index"
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: {
        title: "搜索"
      }
    },
    { path: "*", redirect: "/" } //路由按顺序从上到下，依次匹配。最后一个*能匹配全部，然后重定向到主页面
  ]
});
